import ElCheckbox from './src/checkbox';

/* istanbul ignore next */
ElCheckbox.install = function(Vue) {
  Vue.component(ElCheckbox.name, ElCheckbox);
};

export default ElCheckbox;



//////////////////
// WEBPACK FOOTER
// ./~/.1.4.12@element-ui/packages/checkbox/index.js
// module id = 11
// module chunks = 0